export const AI = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.5 3.39844C7.10468 4.78312 8.21601 5.89512 9.60059 6.5C8.21628 7.10476 7.10476 8.21628 6.5 9.60059C5.89512 8.21601 4.78312 7.10468 3.39844 6.5C4.7834 5.8952 5.8952 4.7834 6.5 3.39844Z"
        stroke="currentColor"
      />
      <path
        d="M13.5 7.84863C14.5399 10.413 16.5861 12.4599 19.1504 13.5C16.5864 14.54 14.54 16.5864 13.5 19.1504C12.4599 16.5861 10.413 14.5399 7.84863 13.5C10.4133 12.46 12.46 10.4133 13.5 7.84863Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};
